export default __webpack_public_path__ + "static/media/customer-jade.0630d2e1.jpg";